export interface GalleryImage {
  small: string;
  largeUncropped: string;
  /**
   * Alt text / visible caption for the image, used for accessibility.
   */
  caption?: string;
  /**
   * The date the image was uploaded, formatted as a human-readable string.
   */
  formattedAddedDate?: string;
}

export enum GalleryViewMode {
  Grid = 'GRID',
  Lightbox = 'LIGHTBOX',
}

export interface PaginationConfig {
  onLoadMore: () => void;
  hasMore: boolean;
  isLoadingMore: boolean;
  totalImageCount: number;
  pageSize: number;
}
